function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';

var tfnrRefreshTokenHof = function tfnrRefreshTokenHof(_ref) {
  var viewInfo = _ref.viewInfo,
      setViewInfo = _ref.setViewInfo,
      setLoginTime = _ref.setLoginTime,
      logout = _ref.logout,
      tfnrApiUrl = _ref.tfnrApiUrl;
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", axios.post("".concat(tfnrApiUrl, "/token"), "grant_type=refresh_token&refresh_token=".concat(viewInfo.refreshToken), {
              headers: {
                Authorization: "Basic ".concat(btoa("".concat(viewInfo.clientKey, ":").concat(viewInfo.clientSecret))),
                channelId: 'G',
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function (_ref3) {
              var data = _ref3.data;

              var newViewInfo = _objectSpread(_objectSpread({}, viewInfo), {}, {
                oauthToken: data.access_token,
                refreshToken: data.refresh_token,
                expiresIn: data.expires_in,
                scope: data.scope,
                tokenType: data.token_type
              });

              setViewInfo(newViewInfo);
              localStorage.setItem('view_info', JSON.stringify(newViewInfo));
              var now = Date.now();
              setLoginTime(now);
              localStorage.setItem('loginTime', JSON.stringify(now));
            }).catch(logout));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

export { tfnrRefreshTokenHof };